import {ActionEnum} from "../action.enum";
import {ContractMenu} from "../../enums/contract/contract-menu.enum";
import {ContractBasicInfo} from "../../models/contract/contract.model";

export namespace ContractDetailAction {

  export class LoadContract {
    static readonly type = ActionEnum.CONTRACT_DETAIL_LOAD_CONTRACT;
    constructor (public id: string) {}
  }

  export class SelectMenu {
    static readonly type = ActionEnum.CONTRACT_DETAIL_SELECT_MENU;
    constructor(public menu: ContractMenu) {}
  }

  export class ResetState {
    static readonly type = ActionEnum.CONTRACT_DETAIL_RESET_STATE;
    constructor () {}
  }

  export class UpdateBasicInfo {
    static readonly type = ActionEnum.CONTRACT_DETAIL_UPDATE_BASIC_INFO;
    constructor (public basicInfo: ContractBasicInfo) {}
  }

  export class UpdateOrgIds {
    static readonly type = ActionEnum.CONTRACT_DETAIL_UPDATE_ORG_IDS;
    constructor (public orgIds: string[], public removedOrgIds: string[]) {}
  }

  export class Delete {
    static readonly type = ActionEnum.CONTRACT_DETAIL_DELETE_CONTRACT;
    constructor () {}
  }
}
